import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M7.187 8.829c.85.85 1.564 1.35 2.013 1.62.319.192.705.188 1.045.039l2.007-.878L16 12.215c-1.736 6.13-7.335 3.954-11.745-.455C-.156 7.351-2.356 1.732 3.78 0l2.607 3.746-.868 2.03c-.144.338-.146.72.043 1.034.27.449.771 1.165 1.625 2.019"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneFilledSize16Glyph.displayName = 'PhoneFilledSize16Glyph';
